'use client';

import { mercadoPagoService } from '@/api/mercadopago/mercadoPagoApi';
import type React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Custom hook for MercadoPago authentication flow and related UI logic.
 */
export function useMercadoPagoAuth() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasMercadoPagoAuth, setHasMercadoPagoAuth] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    /**
     * Checks the MercadoPago authorization status on component mount.
     */
    const checkAuthStatus = async () => {
      const status = await mercadoPagoService.hasMercadoPagoCredentials();
      setHasMercadoPagoAuth(status);
    };
    checkAuthStatus();
  }, []);

  /**
   * Handles navigation to the new tournament creation page,
   * opening a modal if MercadoPago is not authorized.
   * @param e Optional React MouseEvent.
   */
  const handleNavigateNewTournament = (e?: React.MouseEvent) => {
    if (e) e.preventDefault();
    if (hasMercadoPagoAuth) {
      navigate('/crear-torneo');
    } else {
      setIsModalOpen(true);
    }
  };

  /**
   * Initiates the MercadoPago authorization process by redirecting to the auth URL.
   */
  const handleAuthorizeMercadoPago = async () => {
    const { authUrl } = await mercadoPagoService.generateAuthUrl();
    window.location.href = authUrl;
  };

  return {
    isModalOpen,
    setIsModalOpen,
    hasMercadoPagoAuth,
    handleNavigateNewTournament,
    handleAuthorizeMercadoPago,
  };
}
